
import { apiFetch } from '@ami/react/core';

const _baseEndPoint = 'sales/quote-product/lead-time/override';

export default {
  overrideLeadTime: (input) => {
    const leadTimeOverrideInput = new QuoteProductLeadTimeOverrideInput(input);
    return apiFetch(`${_baseEndPoint}`, 'POST', leadTimeOverrideInput);
  },
  removeOverrideLeadTime: (input) => {
    const leadTimeOverrideInput = new QuoteProductLeadTimeRemoveOverrideInput(input);
    return apiFetch(`${_baseEndPoint}`, 'DELETE', leadTimeOverrideInput);
  }
};

export class QuoteProductLeadTimeRemoveOverrideInput {
  constructor(item) {
    if (item) {
      this.productId = item.productId;
      this.state = item.state;
      this.key = item.key;
    }
  }
}

export class QuoteProductLeadTimeOverrideInput {
  constructor(item) {
    if (item) {
      this.productId = item.productId;
      this.state = item.state;
      this.override = new LeadTimeOverride(item.override);
    }
  }
}

export class LeadTimeOverride {
  constructor(item) {
    if (item) {
      this.key = item.key;
      this.value = item.value;
      this.availableOn = item.availableOn;
      this.unit = item.unit;
    }
  }
}
